var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"testimonial-wrapper"},[_c('figcaption',[_vm._t("default")],2),_c('img',{style:(("object-position:" + _vm.position)),attrs:{"src":_vm.img1x,"srcset":_vm.img2x,"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }